module.exports = __webpack_public_path__ + "img/connect-2.d4b3cefb.png";